import React from 'react';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';

export function DeleteRoutingRuleModal({
  deleteId,
  handleClose,
  show,
  handleDeletion,
}) {
  return (
    <Formik
      onSubmit={async (values, actions) => {
        handleDeletion(values.deleteId);
        actions.resetForm({});
        handleClose();
      }}
      enableReinitialize={true}
      initialValues={{
        deleteId: deleteId ?? '',
      }}
    >
      {(formik) => (
        <>
          <form
            className="form form-label-right"
            onSubmit={formik.handleSubmit}
            noValidate
          >
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title="Delete Call Routing Rule(s)"
              aria-labelledby="example-modal-sizes-title-md"
              show={show}
              onHide={handleClose}
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              deleteDialog={true}
              dataPup="delete-dialog-routing-rule"
              size="xs"
            >
              <p>
                Deleting this inbound call routing rule(s) will remove routing
                for numbers associated to this rule. This action cannot be
                reversed.
              </p>
              <p>
                Are you sure you want to delete this inbound call routing
                rule(s)?
              </p>
            </ModalWithStyles>
          </form>
        </>
      )}
    </Formik>
  );
}
